import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../Buttons/Button";
import { updateStockPrice } from "../../store/actions/stocks/updateStockPrice";

function UpdateStockPriceModal({ open, onClose, stock }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.stocks?.updatePricePending);
  const [currentPrice, setCurrentPrice] = useState("");
  const [availableVolume, setAvailableVolume] = useState("");

  useEffect(() => {
    if (open) {
      setCurrentPrice(stock?.current_price ?? "");
      setAvailableVolume(stock?.available_volume ?? "");
    }
  }, [open, stock]);

  const handleSubmit = () => {
    dispatch(
      updateStockPrice({
        id: stock?.id,
        data: {
          current_price: Number(currentPrice),
          available_volume: Number(availableVolume),
        },
        callback: onClose,
      })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">Update Price / Volume</h1>
          <p className="text-sm mb-6 text-[#475467]">
            Update the current price and available volume for{" "}
            {stock?.symbol || "this stock"}.
          </p>

          <label className="text-sm font-[500]">Current Price</label>
          <input
            type="number"
            value={currentPrice}
            onChange={(e) => setCurrentPrice(e.target.value)}
            placeholder="Enter current price"
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-4 outline-none"
          />

          <label className="text-sm font-[500]">Available Volume</label>
          <input
            type="number"
            value={availableVolume}
            onChange={(e) => setAvailableVolume(e.target.value)}
            placeholder="Enter available volume"
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none"
          />

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children="Update"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              disabled={currentPrice === "" || availableVolume === ""}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default UpdateStockPriceModal;
